module.exports = __webpack_public_path__ + "static/media/wifi-1.d4c744e3.svg";